export default "__VITE_ASSET__DdDNzfnz__"